/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {SideSheetView} from '../../types/types';

const isView = (types: SideSheetView[]) => (view): boolean => types.includes(view);

export const isSideSheetTableView     = isView([SideSheetView.table]);
export const isBottomSheetTableView   = isView([SideSheetView.bottomTable]);
export const isSheetTableView         = isView([SideSheetView.table, SideSheetView.bottomTable]);
export const isSideSheetCollapsedView = isView([SideSheetView.collapsed]);
export const isSideSheetDetailedView  = isView([SideSheetView.detailed]);
